import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { UserService } from '@app/user/user.service';
import { filter, map, tap } from 'rxjs/operators';
import { EventService } from '@app/event/event.service';
import { RoutingService } from '@app/routing.service';
import { NavigationEnd, Router } from '@angular/router';
import { EventWrapperComponent } from '@app/shared/pages/event-wrapper/event-wrapper.component';
import { EngineHintService } from '@app/services/engine-hints.service';

export interface NavItem {
  text?: string;
  template?: string;
  to?: string;
  click?: () => void;
  onlyAuth?: boolean;
  onlyGuests?: boolean;
  requiresPermission?: string | string[];
  requiresRole?: string[];
}

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  isAuthenticated: boolean;
  private isEventsPage: boolean;
  private isSplitScreen: boolean;
  public currentUser: any;
  primeItems: any[];

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private eventService: EventService,
    private router: Router,
    private routingService: RoutingService,
  ) {
  }

  @Output() close = new EventEmitter<void>();
  items: NavItem[] = [];

  ngOnInit() {
    this.userService
      .currentUser()
      .pipe(
        map(user => {
          this.isAuthenticated = user.username !== 'guest';
          this.currentUser = user;
          this.regenerateNav();
        })
      )
      .subscribe();

    this.eventService.isSplitScreen$.subscribe(isSplitScreen => {
      this.isSplitScreen = isSplitScreen;
      this.regenerateNav();
    });

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        tap(e => e as NavigationEnd),
        tap((e: NavigationEnd) => {
          if (
            this.routingService.activatedRoute.component ===
            EventWrapperComponent
          ) {

            this.isEventsPage = true;
          } else {
            this.isEventsPage = false;
          }
        }),
        tap(() => {
          this.regenerateNav();
        })
      )
      .subscribe();

    this.regenerateNav();
  }

  logout() {
    this.authService.logout();
  }

  navItemClicked(item: NavItem) {
    this.close.emit();
    if (item.click) {
      item.click();
    }
  }

  regenerateNav() {
    let items: NavItem[] = [
      // {
      //   text: 'Home',
      //   to: '/'
      // },
      {
        text: 'Admin',
        to: '/admin',
        requiresRole: ['admin'] 
      },
      { text: 'Events', to: '/events' },
      {
        text: 'Users',
        to: '/account/users',
        requiresRole: ['business', 'admin']
      },
      {
        text: 'Uploads',
        to: '/uploads',
        requiresPermission: 'video_transcriptions'
      },
      { text: 'Account', to: '/account/settings', onlyAuth: true },
      {
        text: 'Engine Hints',
        to: '/engine-hints',
        onlyAuth: true
      },
      {
        text: 'Logs',
        to: '/logs',
        requiresRole: ['admin']
      },
      {
        text: 'Stream', 
        to: '/stream', 
        requiresRole: ['admin']
      }
      // { text: 'Logout', click: () => this.logout(), onlyAuth: true },
      // { text: 'Login', to: '/login', onlyGuests: true }
    ];

    items = items.filter(item => {
      if (item.requiresRole) {
        return (
          this.currentUser && item.requiresRole.includes(this.currentUser.role)
        );
      }

      if (item.requiresPermission) {
        return (
          this.currentUser &&
          this.currentUser.permissions &&
          this.currentUser.permissions.find(
            permission => permission.name === item.requiresPermission
          )
        );
      }

      if (item.onlyAuth) {
        return this.isAuthenticated;
      }

      if (item.onlyGuests) {
        return !this.isAuthenticated;
      }

      return true;
    });

    this.items = items;
    this.primeItems = this.items.map(item => ({
      target: item.to,
      label: item.text
    }));

    // this.primeItems = [
    //   {
    //     label: 'test',
    //     items: [
    //       {
    //         label: 'hello',
    //         target: '/'
    //       }
    //     ]
    //   }
    // ]
  }
}
